@if (ignoreConfirmation && !forceShowConfirmation()) {
  <app-loading />
}

<section class="section__header">
  <div class="container">
    <div class="section__header__row">
      <div>
        <div class="section__header__title">{{ 'secret-page-hero-title' | translate }}</div>
        <div class="usps">
          @for (USP of USPs(); track USP) {
            <div class="usp">{{ USP.emoji }} {{ USP.text | translate }}</div>
          }
        </div>
        <div class="ratings">
          <div class="ratings__stars"><app-star-rating />&nbsp;4.8</div>
          <div>{{ 'app-ratings' | translate }}</div>
        </div>
      </div>

      <app-discount-code
        [ignoreConfirmation]="ignoreConfirmation"
        [forceShowConfirmation]="forceShowConfirmation()"
        [code]="code"
        [referral]="referral"
        (use)="continue()"
      />
    </div>

    <div class="ratings">
      <div class="ratings__stars"><app-star-rating />&nbsp;4.8</div>
      <div>{{ 'app-ratings' | translate }}</div>
    </div>
  </div>
</section>

<app-measure-steps />

<app-reviews />
